import Vue from 'vue'
import Vuex from 'vuex'
import menu from './modules/menu'
import managlist from './modules/managlist'
import students from './modules/students'
Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    menu,
    managlist,
    students
  },
 
})


export default store